// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Focus Ring System */
.vnsc-root {
  --vnsc-ring-width: 2px;
  --vnsc-ring-offset: 2px;
  --vnsc-ring-color: var(--vnsc-color-primary);
  --vnsc-ring-opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/focus.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,wBAAwB;AAC1B","sourcesContent":["/* Design Tokens - Focus Ring System */\r\n.vnsc-root {\r\n  --vnsc-ring-width: 2px;\r\n  --vnsc-ring-offset: 2px;\r\n  --vnsc-ring-color: var(--vnsc-color-primary);\r\n  --vnsc-ring-opacity: 0.4;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
